import React from 'react';

import withStyles from '@material-ui/core/styles/withStyles';
import Typography from '@material-ui/core/Typography';

import Sports from '../containers/Sports';
import Leagues from './Leagues';
import TeamProfiles from './TeamProfiles';
import Games from '../containers/Games';
import PlayerProfiles from '../containers/PlayerProfiles';
import Tasks from '../containers/Tasks';

import PropTypes from 'prop-types';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

const styles = theme => ({
  content: {
    backgroundColor: '#F4F8F9',
    flexGrow: 1,
    overflowX: 'hidden',
    overflowY: 'auto',
  },
  title: {
    ...theme.Typography,
    color: '#044591',
    margin: 0,
    paddingBottom: theme.spacing(),
  },

  root: {
    flexGrow: 1,
    width: '100%',
    backgroundColor: theme.palette.background.paper,
  },
  tab: {
    padding: 24,
  },
  tabCell: {
    outline: 'none !important',
  },
});

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      {value === index && <div p={3}>{children}</div>}
    </Typography>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `scrollable-auto-tab-${index}`,
    'aria-controls': `scrollable-auto-tabpanel-${index}`,
  };
}

class SportsApiHome extends React.Component {
  state = {
    tabSelected: 0,
  };

  handleChange = (name, value) => {
    this.setState({ [name]: value });
  };

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.content}>
        <Typography className={classes.title} variant="h6" gutterBottom>
          Sports API
        </Typography>
        <div className={classes.root}>
          <AppBar position="static" color="default">
            <Tabs
              value={this.state.tabSelected}
              onChange={(event, value) => {
                this.handleChange('tabSelected', value);
              }}
              indicatorColor="primary"
              textColor="primary"
              variant="scrollable"
              scrollButtons="auto"
              aria-label="scrollable auto tabs example"
            >
              <Tab className={classes.tabCell} label="Sports" {...a11yProps(0)} />

              <Tab className={classes.tabCell} label="Leagues" {...a11yProps(0)} />
              <Tab className={classes.tabCell} label="Team Profiles" {...a11yProps(1)} />
              <Tab
                className={classes.tabCell}
                label="Player Profiles"
                {...a11yProps(2)}
              />
              <Tab className={classes.tabCell} label="Games" {...a11yProps(3)} />
              <Tab className={classes.tabCell} label="Tasks" {...a11yProps(4)} />
            </Tabs>
          </AppBar>

          <div className={classes.tab}>
            <TabPanel value={this.state.tabSelected} index={0}>
              <Sports />
            </TabPanel>

            <TabPanel value={this.state.tabSelected} index={1}>
              <Leagues />
            </TabPanel>

            <TabPanel value={this.state.tabSelected} index={2}>
              <TeamProfiles />
            </TabPanel>

            <TabPanel value={this.state.tabSelected} index={3}>
              <PlayerProfiles />
            </TabPanel>

            <TabPanel value={this.state.tabSelected} index={4}>
              <Games />
            </TabPanel>

            <TabPanel value={this.state.tabSelected} index={5}>
              <Tasks />
            </TabPanel>
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(SportsApiHome);
